import { Box, Button, Group, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useBot, useCollaborateStore, MetricsMessageDetailItem } from '@mygpt/app';

interface Props {
  item: MetricsMessageDetailItem;
}

const QuestionItem: React.FC<Props> = ({ item }) => {
  const { t } = useTranslation();
  const { isAssist } = useCollaborateStore();

  const { botId } = useBot();

  const detail = () => {
    const baseUrl = window.location.origin;
    const url = new URL(`/${isAssist ? 'assist' : 'bot'}/${botId}/records`, baseUrl);
    url.searchParams.append('sessionId', item.session_id);
    url.searchParams.append('messageId', item.id);
    window.open(url.href, '_blank', 'noopener,noreferrer');
  };

  const formatTime = (dateTimeStr: string) => {
    // 将字符串解析为Date对象
    const date = new Date(dateTimeStr);

    // 使用Intl.DateTimeFormat来格式化时间
    const formatter = new Intl.DateTimeFormat('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });

    // 返回格式化的时间
    return formatter.format(date);
  };

  return (
    <Box className="bg-gray-100 rounded-md p-5">
      <Stack>
        <Group gap={5}>
          <Text lh={1} size={'sm'}>
            {t('settings.quota.modal.questions')}
          </Text>
          <span className="w-1 h-1 bg-gray-500 rounded-full" />
          <Text lh={1} size="xs" color="gray.4">
            {formatTime(item.created_at)}
          </Text>
        </Group>
        <Text size="sm">{item.question}</Text>
        <Group justify="space-between">
          <Button variant="outline" color="gray" px={6} py={2} size="compact-xs" radius={5} onClick={detail}>
            {t('settings.quota.modal.answer_details')}
          </Button>
          <Text size="xs" c="gray.4">
            {t('settings.quota.modal.consumed')}: - {item.consumed}
          </Text>
        </Group>
      </Stack>
    </Box>
  );
};

export default QuestionItem;
